import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
    buildDefaultSystemPromptCategories,
    SystemPromptCategory,
} from '../utils/systemPrompt';

// ============================================================================
// AI Agent System Prompt Store
// Persistent, user-editable system prompt sections injected into the hub
// agent's system message via the yap_get_system_prompt MCP bridge tool.
// ============================================================================

interface SystemPromptState {
    /** Master switch — off means the agent receives no custom prompt. */
    enabled: boolean;
    categories: SystemPromptCategory[];

    setEnabled: (enabled: boolean) => void;
    updateCategory: (id: string, patch: Partial<Omit<SystemPromptCategory, 'id'>>) => void;
    resetCategory: (id: string) => void;
    resetAll: () => void;
}

export const useSystemPromptStore = create<SystemPromptState>()(
    persist(
        (set) => ({
            enabled: true,
            categories: buildDefaultSystemPromptCategories(),

            setEnabled: (enabled) => set({ enabled }),

            updateCategory: (id, patch) =>
                set((state) => ({
                    categories: state.categories.map((c) =>
                        c.id === id ? { ...c, ...patch } : c
                    ),
                })),

            resetCategory: (id) =>
                set((state) => {
                    const fresh = buildDefaultSystemPromptCategories().find((c) => c.id === id);
                    if (!fresh) return state;
                    return {
                        categories: state.categories.map((c) =>
                            c.id === id ? { ...fresh } : c
                        ),
                    };
                }),

            resetAll: () =>
                set({
                    enabled: true,
                    categories: buildDefaultSystemPromptCategories(),
                }),
        }),
        {
            name: 'yap-system-prompt',
        }
    )
);
